import Vue from 'vue';
import mixin from './mixin.js';
import Fragment from 'vue-fragment';
import store from '@/store/AppStore';

require(`./assets/${process.env.VUE_APP_BRAND}/scss/_fonts.scss`);
Vue.use(Fragment.Plugin);

window.startupTSVue = new Date().getTime();
if (window.initialData.logins) {
	// JSON.parse required because BE can't print \n they only can do \\n if we want predefined line-breaks HOMEPAGE-3689
	window.initialData.logins = JSON.parse(JSON.stringify(window.initialData.logins).replace('\\\\n', '\\n'));
}

store.commit('setAdServiceParams', window.initialData.serviceResponse._params);
if (window.PageConfig.site === 'hp') {
	store.commit('setAdData', window.initialData.serviceResponse.response);
	store.commit('setAgent', window.initialData.serviceResponse.agent);
} else {
	store.commit('setRequestData', window.initialData.request);
}

store.commit('setContentData', window.initialData);

new Vue({
	el: '#app',
	mixins: [mixin],
	store,
	components: {
		'hp-app': require('./App.vue').default
	}
});
